// development.js
const config = {
  API_URL: "http://localhost:5000/api",
  FEATURE_TOGGLE: true,
};

export default config;
